import { AccountMultipleMinusIcon } from './AccountMultipleMinusIcon';

/**
 * author: Google
 * id BD31FA9F-EC76-44E9-A9F3-A85F83045D78
 * name account-multiple-minus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-minus.svg
 * tags
 * - Account / User 
 */
export const AccountsMinusIcon = AccountMultipleMinusIcon;
export default AccountsMinusIcon